import { defineMessages } from 'react-intl';

export default defineMessages({
    body_data_route_label: {
        id: 'routes.body_data_route_label',
        defaultMessage: 'Body Data',
        description: 'Body Data route text',
    },
    product_matches_route_label: {
        id: 'routes.product_matches_route_label',
        defaultMessage: 'Product Matches',
        description: 'Product matches route text',
    },
    sessions_route_label: {
        id: 'routes.sessions_route_label',
        defaultMessage: 'Sessions',
        description: 'Sessions route text',
    },
    locations_route_label: {
        id: 'routes.locations_route_label',
        defaultMessage: 'Locations',
        description: 'Locations route text',
    },
    terms_of_service_route_label: {
        id: 'routes.terms_of_service_route_label',
        defaultMessage: 'Terms of Service',
        description: 'Terms of service route text',
    },
    privacy_policy_route_label: {
        id: 'routes.privacy_policy_route_label',
        defaultMessage: 'Privacy Policy',
        description: 'Privacy Policy route text',
    },
    account_profile_route_label: {
        id: 'routes.account_profile_route_label',
        defaultMessage: 'Account & Rider Profiles',
        description: 'Account & Rider Profiles route text',
    },
    create_account_route_label: {
        id: 'routes.create_account_route_label',
        defaultMessage: 'Create Account',
        description: 'Create Account route text',
    },
    sign_in_route_label: {
        id: 'routes.sign_in_route_label',
        defaultMessage: 'Sign In',
        description: 'Sign In route text',
    },
    forgot_password_route_label: {
        id: 'routes.forgot_password_route_label',
        defaultMessage: 'Forgot Password',
        description: 'Forgot Password route text',
    },
    verify_route_label: {
        id: 'routes.verify_route_label',
        defaultMessage: 'Verify Account',
        description: 'Verify account route text',
    },
    reset_password_route_label: {
        id: 'routes.reset_password_route_label',
        defaultMessage: 'Reset Password',
        description: 'Reset Password route text',
    },
    set_password_route_label: {
        id: 'routes.set_password_route_label',
        defaultMessage: 'Set Password',
        description: 'Set Password route text',
    },
    not_found_route_label: {
        id: 'routes.not_found_route_label',
        defaultMessage: 'Not Found',
        description: 'Not found route text',
    },
});



// WEBPACK FOOTER //
// ./src/routes/messages.js